import { usePeriodCountdown } from '@/hooks/use-period-countdown';

import { InfoIcon } from '@/components/svg-icons';

export const ResetTimeIndicator = ({ 
	description, 
	resetTime 
}: { 
	description?: string, 
	resetTime: string 
}) => {
	const countdownHours = usePeriodCountdown(resetTime);
	
	return (
		<>
			<div className="shop-coin-text">
				{description?.replace('{X}', String(countdownHours))}
			</div>
			<InfoIcon />
		</>
	);
};